var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.50434L12.6667 5.83768V2.66634H6.66668V5.99967H3.33335V13.333H12.6667V11.495L14 10.1617V14.005C13.9998 14.1805 13.93 14.3487 13.8059 14.4727C13.6818 14.5967 13.5135 14.6663 13.338 14.6663H2.66202C2.57447 14.6657 2.4879 14.6479 2.40725 14.6138C2.3266 14.5797 2.25345 14.5301 2.19197 14.4678C2.1305 14.4054 2.08191 14.3316 2.04897 14.2505C2.01604 14.1694 1.9994 14.0826 2.00002 13.995V5.33301L6.00202 1.33301H13.332C13.7 1.33301 14 1.63634 14 1.99434V4.50434ZM14.5187 5.87101L15.4613 6.81434L10.276 11.9997L9.33202 11.9983L9.33335 11.057L14.5187 5.87167V5.87101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.1366fdb52d6d6799de71a28159513db1.svg";
export { ForwardRef as ReactComponent };